module.exports = __webpack_public_path__ + "js/0.c2a39d0f.worker.js"